export function getCookie (key) {
    const b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

export function createCookie (name, value, days) {
    let date = new Date(), expires = '';
    if (days) {
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    }
    else {
        expires = '';
    }
    document.cookie = name + '=' + value + expires + `; path=/; domain=${process.env.REACT_APP_COOKIE_DOMAIN}`;
}

export function setCookieResponse (accepted) {
    createCookie('cookielaw_accepted', accepted, 364);
    document.getElementById('cookieBannerContainer').style.display = 'none';
    window.location.reload();
}

export function shouldAllowCookies () {
    const cookielawCookie = getCookie('cookielaw_accepted');
    const cookiesAccepted = cookielawCookie === '1' || cookielawCookie === 1;
    let dntEnabled = false;
    if (window.doNotTrack === '1' || navigator.doNotTrack === '1' || navigator.doNotTrack === 'yes') {
        dntEnabled = true;
    }
    return cookiesAccepted && !dntEnabled;
}

export function shouldShowCookieBanner () {
    const cookielawCookie = getCookie('cookielaw_accepted');
    if (cookielawCookie.toString() !== '0' && cookielawCookie.toString() !== '1') {
        return true;
    }
    return false;
}